import { Component } from '@angular/core'
import { appConfig } from '../../../brands/_current/config/app-config'

@Component({
  selector: 'app-generic-error-page',
  templateUrl: './generic-error-page.component.html',
  styleUrls: ['./generic-error-page.component.scss'],
})
export class GenericErrorPageComponent {
  public helplineNumber = appConfig.core.helplineNumber

  constructor() {}
}
